// extracted by mini-css-extract-plugin
export default {"contestInfo":"ContestInfo_contestInfo__Bv66i"};